import { getSrcConfigs } from 'communicator/store/selectors';
import { SRCConfigs } from 'types/data';

export default function fetchConfigs(): SRCConfigs {
  return getSrcConfigs();
}
